/* eslint-disable no-unused-expressions */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
const React = require('react');
const PropTypes = require('prop-types');
const Breadcrumb = require('@andes/breadcrumb');
const MenuUtils = require('../../../utils/menu');
const { sanitizePath } = require('../URLSanitizer');

const { BreadcrumbLevel } = Breadcrumb;

const BreadCrumbs = ({ lang, path, platform, i18n }) => {
  const item = MenuUtils.getItemFromURL(sanitizePath(path), platform.siteId, lang, 'guides');
  let actualLevel = [item];
  const levels = [
    {
      text: i18n.gettext('Documentación'),
      id: '1',
      href: `/developers/${lang}/docs`,
    },
    {
      text: actualLevel[0]?.title,
      id: (actualLevel[0]?.lvl + 2).toString(),
      disabled: true,
    },
  ];

  function getLinkRedirect(actLevel, oneLevelUp, parentUrl) {
    if (actLevel?.url === '' && oneLevelUp) {
      return `/developers/${lang}${oneLevelUp}`;
    } if (actLevel?.url === '' && !oneLevelUp && parentUrl) {
      const parentElementBase = MenuUtils.getItemById(actLevel.id, 'guides', lang, platform?.siteId);
      const firstChildURL = MenuUtils.getFirstChildURLOfItem(parentElementBase);
      return firstChildURL ? `/developers/${lang}${firstChildURL}` : `/developers/${lang}/${parentUrl}`;
    }
    return `/developers/${lang}${actLevel?.url}`;
  }

  let parent = [actualLevel[0]?.parentItem];
  actualLevel = [parent[0]];
  let { parentItem, childs, title, lvl } = actualLevel[0] || {};
  const oneLevelUp = (childs && childs.length > 0) ? childs[0].url : null;

  while (actualLevel[0]?.hasOwnProperty('parentItem')) {
    const currentLevel = actualLevel[0];
    const linkRedirect = getLinkRedirect(currentLevel, oneLevelUp, parentItem?.url);

    levels.push({ text: title, id: (lvl + 2).toString(), href: linkRedirect });

    parent = [currentLevel.parentItem];
    actualLevel = [parent[0]];

    ({ parentItem, childs, title, lvl } = actualLevel[0] || {});
  }

  const lastLevel = actualLevel[0];
  levels.push({
    text: lastLevel.title,
    id: (lastLevel.lvl + 2).toString(),
    href: `/developers/${lang}${lastLevel.url}`,
  });

  const levelsSortedById = levels.sort((a, b) => ((a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0)));
  if (levelsSortedById[1].text === levelsSortedById[2].text) {
    levelsSortedById.splice(1, 1);
  }

  return (
    <Breadcrumb srLabel="List of pages">
      {levelsSortedById.map(element => <BreadcrumbLevel {...element} />)}
    </Breadcrumb>
  );
};

BreadCrumbs.propTypes = {
  i18n: PropTypes.shape({
    gettext: PropTypes.func.isRequired,
  }).isRequired,
  platform: PropTypes.shape({
    siteId: PropTypes.string.isRequired,
    domain: PropTypes.string.isRequired,
  }).isRequired,
  lang: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
};

BreadCrumbs.defaultProps = {
  i18n: { gettext: () => { } },
};

module.exports = BreadCrumbs;
